<template>
  <div>
    <form @submit.prevent="preparePatchGroup">
      <AppTextField ref="inputText"
                    v-model.trim="v$.newGroupName.$model"
                    outlined
                    autofocus
                    dense
                    counter="100"
                    maxlength="100"
                    @keydown.esc="$emit('cancel')"
      >
        <template #append-inner>
          <AppButton icon
                     size="small"
                     class="edition-button mr-2"
                     :disabled="loading"
                     @click="$emit('cancel')"
          >
            <font-awesome-icon :icon="['fad', 'circle-xmark']" style="font-size: 20px;" />
          </AppButton>
          <AppButton color="success"
                     icon
                     class="edition-button edition-button--success"
                     :loading="loading"
                     :disabled="loading"
                     @click="preparePatchGroup"
          >
            <font-awesome-icon :icon="['fad', 'circle-check']" style="font-size: 20px;" />
          </AppButton>
        </template>
      </AppTextField>
    </form>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { maxLength, required } from '@vuelidate/validators'
import { nextTick } from 'vue'
import { mapActions } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import AppButton from '@/common/buttons/AppButton.vue'
import { toast } from '@/common/utils/toast'

export default {
  name: 'GroupNameEdit',
  components: { AppTextField, AppButton },
  setup: () => ({ v$: useVuelidate() }),
  validations: {
    newGroupName: {
      required,
      maxLength: maxLength(100),
    },
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      newGroupName: '',
      loading: false,
    }
  },
  async mounted () {
    this.newGroupName = this.group.name
    await nextTick()
    this.$refs.inputText.$el.querySelector('input').select()
  },
  methods: {
    ...mapActions('groups', ['PATCH_GROUP', 'GET_GROUPS']),
    async preparePatchGroup () {
      if (this.newGroupName !== this.group.name && this.newGroupName && !this.loading) {
        this.v$.$touch()
        if (!this.v$.$invalid) {
          this.loading = true
          try {
            await this.PATCH_GROUP({
              groupId: this.group.id,
              data: {
                name: this.newGroupName,
              },
            })

            await this.GET_GROUPS(this.$route.params.mnemo)

            toast.success(this.$t('project.members.GroupNameEdit.patchGroupSuccess'))
          } catch (e) {
            toast.error(this.$t('project.members.GroupNameEdit.patchGroupError'))
          } finally {
            this.loading = false
            this.$emit('cancel')
          }
        }
      } else {
        this.$emit('cancel')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edition-button {
  &.v-btn.v-btn--icon {
    width: 20px;
    height: 20px;
    padding: 0 !important;
  }

  &--success {
    :deep(.fa-secondary) {
      opacity: 0;
    }
  }
}
</style>
